/* eslint-disable max-len */
import { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import Button from "../../components/Button";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { Col, Row } from "../../components/StyledGridSystem";
import { StyledText } from "../../components/Text";
import StyledTable from "../../components/StyledTable";
import StyledEvent from "../../components/StyledEvent";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import generateCalendar, {
  generateDates,
  generateHeaderwidth,
  generateOptionalCalendar,
  generateSampleTimeLineDates,
} from "../../hooks/generateCalendar";
import { useLocation, useNavigate } from "react-router-dom";
import { SemesterContext } from "../../context/SemesterContext";
import LoadingSpinner from "../../components/LoadingSpinner";
import { StyledAddButton } from "../RoadMap/RoadMap";
import Icon from "../../components/Icon";
import { Menu, MenuItem, Icon as MuiIcon } from "@mui/material";
import SelectStudentModal from "../../components/SelectStudentModal";
import { LocationInterface } from "../../components/UtilsComponents";
import StudentHistoryModel from "../../components/StudentHistoryModel";
import Pill from "../../components/Pill";
import SnackBar from "../../components/SnackBar";
import moment from "moment";
import CompetencyDetailModal from "../../components/CompetencyDetailModal";
import TabGroup, { TabItem } from "../../components/TabGroup";
import theme from "../../styles/theme";
import { PillarList } from "./pillarList";
import { CompetencyList } from "./CompetencyList";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import { StyleElements } from "../RoadMap/StudentTimelines";
import MinimalSelect from "../../components/MinimalSelect";
import { UniversityContext } from "../../context/UniversityContext";
import {
  findPillarForCompetency,
  getCardGraphics,
  getCompetencyPillarPrefix,
} from "../../utils/cardGraphics";

const CustomFlex = styled(FlexBox)<{ $sidebarOpen: boolean }>`
  left: ${({ $sidebarOpen }) => ($sidebarOpen ? "255px" : "75px")};
  z-index: 1000;
  position: fixed;
  top: 0px;
  height: 74px;
}
`;

type Student = {
  advisor: string;
  cmkl_id: string;
  current_status: any;
  curriculum_version: number;
  display_version: string;
  email: string;
  expect_last_term: string;
  first_name: string;
  first_term: string;
  id: string;
  last_name: string;
  last_term: string;
  nickname: string;
  program: string;
  program_id: string;
  study_year: string;
  university_code: string;
};
function InstructorStudentCard() {
  const screenClass = useScreenClass();
  let location = useLocation() as LocationInterface;
  const stateData = location.state;
  const [loading, setLoading] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState<boolean>(false);
  // const [selectedStudent, setSelectedStudent] = useState<any>();
  const currentUser = useContext(UserContext).user;
  const userContext = useContext(UserContext);
  const semesterContext = useContext(SemesterContext);
  const isMobile = useMemo(
    () => ["xs", "sm", "md"].includes(screenClass),
    [screenClass],
  );
  const universityContext = useContext(UniversityContext);

  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [inProgress, setInProgress] = useState<Array<any>>([]);
  const [completed, setCompleted] = useState<Array<any>>([]);
  const [archived, setArchived] = useState<Array<any>>([]);
  const [selectedCompetency, setSelectedCompetency] = useState<{}>();
  const [selectedPillar, setSelectedPillar] = useState<any>();
  const [progressCredits, setProgressCredits] = useState<string>("0");
  const [earnedCredits, setEarnedCredits] = useState<string>("0");
  const [archivedCredits, setArchivedCredits] = useState<string>("0");

  // const { t, i18n } = useTranslation();
  const [tab, setTab] = useState(0);
  // const selectedStudent: any = JSON.parse(
  //   localStorage.getItem("selectedStudent") as string
  // );

  const [selectedStudent, setSelectedStudent] = useState<Student>({
    advisor: "",
    cmkl_id: "",
    current_status: "",
    curriculum_version: 0,
    display_version: "",
    email: "",
    expect_last_term: "",
    first_name: "",
    first_term: "",
    id: "",
    last_name: "",
    last_term: "",
    nickname: "",
    program: "",
    program_id: "",
    study_year: "",
    university_code: "",
  });
  const [currentVersionPillar, setCurrentVersionPillar] = useState<any>([]);
  useEffect(() => {
    const stored = localStorage.getItem("selectedStudent");
    let studentId = selectedStudent?.id;

    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSelectedStudent(parsed);
        studentId = parsed?.id;
      } catch (e) {
        console.error("Failed to parse student", e);
      }
    }

    setSelectedPillar(null);
    fetchAllPillars(studentId);
  }, [
    semesterContext,
    stateData,
    selectedStudent?.id,
    universityContext.selectedProgram,
  ]);

  const loadStudentCardData = (id: string) => {
    if (id) {
      fetchCompetencies(id);
      fetchCredits(id);
    } else {
      fetchCompetencies("");
      fetchCredits("");
    }
  };

  const fetchCompetencies = (id: string) => {
    if (id) {
      setLoading(true);
      axios
        .get(
          `/student/cards?student_id=${id}&program_name=${
            universityContext.selectedProgram?.value === "ALL"
              ? JSON.parse(localStorage.getItem("selectedStudent") || "{}")
                  ?.programs?.[0]?.program_name
              : universityContext.selectedProgram?.value
          }`,
        )
        .then((res) => {
          setInProgress(
            res.data.card_info.cards.filter(
              (item: { status: string; competency_code: string }) =>
                (item.status === "Selected" || item.status === "In progress" || item.status === "Completed") &&
                !item.competency_code.includes("SOF"),
            ),
          );
          setCompleted(
            res.data.card_info.cards
              .sort(
                (
                  a: { competency_code: string },
                  b: { competency_code: string },
                ) => a.competency_code.localeCompare(b.competency_code),
              )
              .filter(
                (item: { status: string; competency_code: string }) =>
                  (item.status === "Recorded") &&
                  !item.competency_code.includes("SOF"),
              ),
          );
          setArchived(
            res.data.card_info.cards.filter(
              (item: { status: string; competency_code: string }) =>
                item.status === "Archived" &&
                !item.competency_code.includes("SOF"),
            ),
          );
          setArchivedCredits(
          res.data.card_info.cards
            .filter((item: { status: string; competency_code: string }) =>
              (item.status === "Archived") &&
              !item.competency_code.includes("SOF")
            )
            .reduce((total: number, item: any) => total + item.credits, 0)
            .toString()
        );
          setCompetencies(
            res.data.card_info.cards.filter(
              (item: { status: string; competency_code: string }) =>
                (item.status === "Selected" ||
                  item.status === "Recorded" ||
                  item.status === "Completed" ||
                  item.status === "In progress") &&
                !item.competency_code.includes("SOF"),
            ),
          );
          setLoading(false);
        })
        .catch((err) => {
          handleJWTError(err);
          setInProgress([]);
          setCompleted([]);
          setCompetencies([]);
          setLoading(false);
        });
    }
  };
  const fetchCredits = (id: string) => {
    if (id) {
      setLoading(true);
      axios
        .get(`/student/credit?student_id=${id}`)
        .then((res) => {
          setProgressCredits(
            res.data.credit.overall_credit.total_working_credits,
          );
          setEarnedCredits(res.data.credit.overall_credit.total_earned_credits);
          setLoading(false);
        })
        .catch((err) => {
          handleJWTError(err);

          setProgressCredits("0");
          setEarnedCredits("0");
          setLoading(false);
        });
    }
  };

  const fetchAllPillars = async (studentId = selectedStudent?.id) => {
    try {
      const versionRes = await axios.get(`/version?university_code=CMKL`);
      const activeVersion = versionRes.data.versions.find(
        (v: any) => v.status === "Active Prime",
      )?.version_number;

      if (!activeVersion) {
        setCurrentVersionPillar([]);
        loadStudentCardData(studentId || "");
        return;
      }

      const subdomainRes = await axios.get(
        `/subdomain?curriculum_version=${activeVersion}`,
      );
      const pillars = subdomainRes.data.pillars ?? [];
      setCurrentVersionPillar(pillars);
      loadStudentCardData(studentId || "");
    } catch (err) {
      handleJWTError(err);
      setLoading(false);
    }
  };

  const transformData = (cards: any) => {
    // Use a Map to group data by `pillar_title`
    const groupedData = new Map();

    cards?.forEach((card: any) => {
      const {
        competency_code,
        title,
        pillar_title,
        id,
        description,
        subdomain_title,
        required,
        credits,
        status_val,
        status,
        mastery_level,
        mastery_level_title,
        transferred,
        earned,
        curriculum_version,
        total_skills,
        assessed_skills,
        skills,
        card_history_events,
        affect_gpa,
        semester_name,
        university_code,
        graphics,
        template_pillar_id,
      } = card;

      const pillar_prefix = getCompetencyPillarPrefix(competency_code);
      const matchedPillar = findPillarForCompetency(
        currentVersionPillar,
        competency_code,
        template_pillar_id
      );

      if (!groupedData.has(pillar_prefix)) {
        groupedData.set(pillar_prefix, {
          pillar_prefix,
          pillar_title: matchedPillar?.title || pillar_title,
          competencies: [],
        });
      }

      groupedData?.get(pillar_prefix)?.competencies?.push({
        id,
        pillar_title,
        title,
        competency_code,
        description,
        subdomain_title,
        required,
        credits,
        status_val,
        status,
        mastery_level,
        mastery_level_title,
        transferred,
        earned,
        curriculum_version,
        total_skills,
        assessed_skills,
        skills,
        card_history_events,
        affect_gpa,
        semester_name,
        university_code,
        graphics: getCardGraphics(
          { competency_code, graphics, template_pillar_id },
          currentVersionPillar
        ),
      });
    });

    // Convert the Map values to an array
    return Array.from(groupedData.values());
  };

  const completedPillars = transformData(completed);
  const inProgressPillars = transformData(inProgress);
  const archivedPillars = transformData(archived);
  const allPillars = transformData(competencies);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRemoveStudent = () => {
    localStorage.removeItem("selectedStudent");
    setSelectedStudent({
      advisor: "",
      cmkl_id: "",
      current_status: "",
      curriculum_version: 0,
      display_version: "",
      email: "",
      expect_last_term: "",
      first_name: "",
      first_term: "",
      id: "",
      last_name: "",
      last_term: "",
      nickname: "",
      program: "",
      program_id: "",
      study_year: "",
      university_code: "",
    });
    setInProgress([]);
    setCompleted([]);
    setCompetencies([]);
    setSelectedCompetency(undefined);
    handleMenuClose();
  };

  const handleSelectStudent = () => {
    setIsModalOpen(true);
    handleMenuClose();
  };
  return (
    <>
      <SnackBar
        isOpen={isErrorOpen && !!selectedStudent}
        setOpen={setIsErrorOpen}
        message={"No milestones for the selected student"}
        header="Error!"
        type="error"
      />
      {selectedCompetency && (
        <CompetencyDetailModal
          selectedStudent={selectedStudent?.id}
          isOpen={isDetailModalOpen}
          setOpen={setIsDetailModalOpen}
          data={selectedCompetency}
          fetchParent={() => {
            fetchCompetencies(currentUser.id);
            fetchCredits(currentUser.id);
          }}
        />
      )}
      {isModalOpen && (
        <SelectStudentModal
          isOpen={isModalOpen}
          setOpen={setIsModalOpen}
          setStudent={(stu) => {
            setSelectedStudent(stu);
            localStorage.setItem("selectedStudent", JSON.stringify(stu));
            // semesterContext.setSemester(
            //   // semesterContext?.semesters?.[
            //   //   semesterContext?.semesters?.length - 1
            //   // ]
            //   semesterContext?.semesters?.find(
            //     (sem) =>
            //       sem.label ===
            //       stu?.programs?.[0]?.current_status?.semester_name
            //   ) ||
            //   semesterContext?.semesters?.[
            //     semesterContext?.semesters?.length - 1
            //   ]
            // );
            semesterContext.setStudent(stu);
            fetchCompetencies(stu.id);
            // window.location.reload();
          }}
        />
      )}
      {selectedStudent && isHistoryModalOpen && (
        <StudentHistoryModel
          isOpen={isHistoryModalOpen}
          setOpen={setIsHistoryModalOpen}
          data={selectedStudent}
          semesterStart={semesterContext.selectedSemester.start_date}
          semesterEnd={semesterContext.selectedSemester.end_date}
        />
      )}
      <CustomFlex $sidebarOpen={userContext.roadmapView.sidebar}>
        <FlexGrow style={{ flexGrow: 0 }}>
          {selectedStudent.id ? (
            <>
              <StyledAddButton
                style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
                onClick={handleMenuClick}
              >
                <Icon
                  fixedWidth={false}
                  style={{ width: "24px", height: "24px" }}
                  size={3}
                  mr={1}
                  name="user"
                />
                {selectedStudent.nickname}
              </StyledAddButton>
              <Menu
                id="student-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                MenuListProps={{
                  "aria-labelledby": "student-button",
                }}
              >
                <MenuItem
                  onClick={handleRemoveStudent}
                  style={{ color: "#ff1100" }}
                >
                  <Icon name="user-minus" mr={1} />
                  Remove Current Student
                </MenuItem>
                <MenuItem
                  onClick={handleSelectStudent}
                  style={{ color: "#305ed7" }}
                >
                  <Icon name="exchange" mr={1} />
                  Change Student
                </MenuItem>
              </Menu>
            </>
          ) : (
            <StyledAddButton
              style={{ margin: 0, whiteSpace: "nowrap", fontWeight: "600" }}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <Icon
                fixedWidth={false}
                style={{ width: "24px", height: "24px" }}
                size={3}
                mr={1}
                name="user"
              />
              Select Student
            </StyledAddButton>
          )}
        </FlexGrow>
        <FlexGrow style={{ flexGrow: 0 }}>
          {/* hide until Christine fixes the api */}
          {/* <StyleElements>
            <MinimalSelect
              setClass={"custom-container"}
              // setClass={"rs-container"}
              required
              placeholder="Program"
              options={universityContext.programs}
              value={universityContext.programs?.find(
                (v: any) =>
                  v.program_abbrev ===
                  universityContext.selectedProgram?.program_abbrev
              )}
              onChange={(newValue: any) => {
                universityContext.setProgram(newValue);
              }}
            />
          </StyleElements> */}
        </FlexGrow>
      </CustomFlex>
      <Row>
        <Col>
          <TabGroup>
            <TabItem
              isMobile={isMobile}
              active={tab === 0}
              onClick={() => {
                setTab(0);
                setSelectedPillar(null);
              }}
            >
              IN PROGRESS ({inProgress.length} Cards)
            </TabItem>
            <TabItem
              isMobile={isMobile}
              active={tab === 1}
              onClick={() => {
                setTab(1);
                setSelectedPillar(null);
              }}
            >
              EARNED ({completed.length} Cards)
            </TabItem>
            <TabItem
              isMobile={isMobile}
              active={tab === 3}
              onClick={() => {
                setTab(3);
                setSelectedPillar(null);
              }}
            >
              EARNED & IN PROGRESS ({competencies.length} Cards)
            </TabItem>
            <TabItem
              isMobile={isMobile}
              active={tab === 2}
              onClick={() => {
                setTab(2);
                setSelectedPillar(null);
              }}
            >
              ARCHIVED ({archived.length} Cards)
            </TabItem>
            {tab === 0 &&
              (isMobile ? (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "0", fontSize: "14px" }}
                >
                  Credits: {progressCredits}
                </StyledText>
              ) : (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "-8px 0 0 12px", fontSize: "20px" }}
                >
                  Credits: {progressCredits}
                </StyledText>
              ))}
            {tab === 3 &&
              (isMobile ? (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "0", fontSize: "14px" }}
                >
                  Total Credits:{" "}
                  {parseInt(progressCredits) + parseInt(earnedCredits)}
                </StyledText>
              ) : (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "-8px 0 0 12px", fontSize: "20px" }}
                >
                  Total Credits:{" "}
                  {parseInt(progressCredits) + parseInt(earnedCredits)}
                </StyledText>
              ))}
            {tab === 1 &&
              (isMobile ? (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "0", fontSize: "14px" }}
                >
                  Credits earned: {earnedCredits}
                </StyledText>
              ) : (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "-8px 0 0 12px", fontSize: "20px" }}
                >
                  Credits earned: {earnedCredits}
                </StyledText>
              ))}
            {tab === 2 &&
              (isMobile ? (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "0", fontSize: "14px" }}
                >
                  Total Credits: {parseInt(archivedCredits)}
                </StyledText>
              ) : (
                <StyledText
                  fontWeight="500"
                  style={{ margin: "-8px 0 0 12px", fontSize: "20px" }}
                >
                  Total Credits: {parseInt(archivedCredits)}
                </StyledText>
              ))}
          </TabGroup>

          {tab === 0 && (
            <>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <>
                  {selectedPillar ? (
                    <CompetencyList
                      setSelectedCompetency={setSelectedCompetency}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      setSelectedPillar={setSelectedPillar}
                      selectedPillar={selectedPillar}
                    />
                  ) : (
                    <PillarList
                      data={inProgressPillars}
                      setSelectedPillar={setSelectedPillar}
                    />
                  )}
                </>
              )}
            </>
          )}
          {tab === 1 && (
            <>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <>
                  {selectedPillar ? (
                    <CompetencyList
                      setSelectedCompetency={setSelectedCompetency}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      setSelectedPillar={setSelectedPillar}
                      selectedPillar={selectedPillar}
                    />
                  ) : (
                    <PillarList
                      data={completedPillars}
                      setSelectedPillar={setSelectedPillar}
                    />
                  )}
                </>
              )}
            </>
          )}
          {tab === 2 && (
            <>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <>
                  {selectedPillar ? (
                    <CompetencyList
                      setSelectedCompetency={setSelectedCompetency}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      setSelectedPillar={setSelectedPillar}
                      selectedPillar={selectedPillar}
                    />
                  ) : (
                    <PillarList
                      data={archivedPillars}
                      setSelectedPillar={setSelectedPillar}
                    />
                  )}
                </>
              )}
            </>
          )}
          {/* {tab === 2 && (
            <>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <>
                  <FlexBox
                    alignItems="flex-start"
                    style={{
                      marginBottom: theme.spacing.x2,
                    }}
                  >
                    {archived.map((competency: any) => (
                      <CustomBlock
                        backgroundColor={competency.graphics.iconbg}
                        onClick={() => {
                          setSelectedCompetency(competency);
                          setIsDetailModalOpen(true);
                        }}
                      >
                        <StyledImg
                          src={
                            competency.graphics.imgurl
                              ? process.env.REACT_APP_IMG_URL +
                                competency.graphics.imgurl
                              : defaultImg
                          }
                          alt=""
                        />
                        <MuiIcon
                          sx={{
                            color: "white",
                            padding: "6px",
                            background: competency.graphics.iconbg,
                            borderRadius: "100px",
                            fontSize: "27px",
                            position: "absolute",
                            bottom: "90px",
                            right: "80px",
                            boxShadow: competency.graphics.iconshadow,
                          }}
                        >
                          {competency.graphics.icon}
                        </MuiIcon>
                        <StyledText fontWeight="700">
                          {competency.title}
                        </StyledText>
                      </CustomBlock>
                    ))}
                  </FlexBox>
                </>
              )}
            </>
          )} */}
          {tab === 3 && (
            <>
              {loading ? (
                <LoadingSpinner />
              ) : (
                <>
                  {selectedPillar ? (
                    <CompetencyList
                      setSelectedCompetency={setSelectedCompetency}
                      setIsDetailModalOpen={setIsDetailModalOpen}
                      setSelectedPillar={setSelectedPillar}
                      selectedPillar={selectedPillar}
                    />
                  ) : (
                    <PillarList
                      data={allPillars}
                      setSelectedPillar={setSelectedPillar}
                    />
                  )}
                </>
              )}
            </>
          )}
          {!selectedStudent && (
            <Pill
              style={{
                background: "#ff002447",
                position: "absolute",
                top: "30vh",
                left: "47%",
                fontSize: "x-large",
                padding: 20,
              }}
            >
              Select a student
            </Pill>
          )}
        </Col>
      </Row>
    </>
  );
}
export default InstructorStudentCard;
